module.exports = __webpack_public_path__ + "static/media/pradaparadox.e7c1e84b.png";